<template>
 
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
